$(function () {
    window.scrollToElement = function(target) {
        let offset = -5; // -5 omdat de box shadow meegenomen wordt in de hoogte van de header maar die is lichtelijk doorzichtbaar dus kan je eventueel een kleine primary/secondary streep (van de vorige module) zien als je een anchor link gebruikt, door het op 5 te zetten heb je 5 pixels speling (teveel) waardoor je deze streep dus niet zal zien

        if ($('.top-bar').css('display') !== 'none') {
            offset += $('.top-bar').outerHeight();
        }
        offset += $('.header').outerHeight();

        $('html, body').animate({
            scrollTop: $(target).offset().top - offset,
        }, 500);
    };

    $('a[href*="#"]:not([href="#"])').on('click', function (event) {
        const target = $(this).attr('href');

        if (!$(target).length) {
            return;
        }

        event.preventDefault();

        window.scrollToElement(target);
    });

    // url.nl/?scroll=ELEMENT
    if (window.location.search.indexOf('?scroll=') !== -1) {
        window.scrollToElement('#' + window.location.search.replace('?scroll=', ''));
    }

    // url.nl/#ELEMENT
    if (window.location.hash !== '') {
        window.scrollToElement(window.location.hash);
    }
});
